import React, { useEffect, useState } from "react";

import SystemAnnouncements from "./SystemAnnouncements";
import UserTermAndConditions from "./dashboard/UserTermAndConditions";
import { useSelector } from "react-redux";
import { ConditionalBlock } from '../ConditionalBlock';

const AppStartupPopups = () => {

  const [termAndConditionsToAccept, setTermAndConditionsToAccept] = useState(null);
  const [systemAnnouncementsToShow, setSystemAnnouncementsToShow] = useState(null);
  const [popupToDisplay, setPopupToDisplay] = useState(null);

  const bootstrapData = useSelector(store => store.customer_bootstrap_data).value;
  const systemAnnouncements = bootstrapData?.systemAnnouncements;
  const termsAndConditions = bootstrapData?.termsConditionsToAccept;


  useEffect(() => {
    setSystemAnnouncementsToShow(systemAnnouncements);
    setTermAndConditionsToAccept(termsAndConditions);

    if(termsAndConditions != null && termsAndConditions !== ""){//first priority to show terms and conditions to accept if any
        setPopupToDisplay("UserTermAndConditions");
    }else if(systemAnnouncements?.length > 0 && localStorage.getItem("announcementSeen") !== "yes"){
        setPopupToDisplay("SystemAnnouncements");
    }
  },[bootstrapData]);


  return (
    <>
        <ConditionalBlock condition={popupToDisplay === "UserTermAndConditions"}>
            <UserTermAndConditions termAndConditionsToAccept={termAndConditionsToAccept}/>
        </ConditionalBlock>

        <ConditionalBlock condition={popupToDisplay === "SystemAnnouncements"}>
            <SystemAnnouncements systemAnnouncementsToShow={systemAnnouncementsToShow}/>
        </ConditionalBlock>
    </>
  );
}

export default AppStartupPopups;
